import pluralize from 'pluralize';
import { serviceBillingModel, serviceModel } from "../../../models";
import { getExpirationDateMessage } from "../ClientOnboarding.utils";
export function getBillingBadgeText(service) {
  const billing = serviceModel.billingTrigger(service);
  const maxCharges = serviceModel.maxChargesEnabled(service) ? serviceModel.maxChargesLimit(service) : null;
  const recurrencePeriod = serviceBillingModel.isRecurring(billing) ? serviceModel.recurrencePeriod(billing) : null;
  const handleRecurring = () => ({
    text: "Billed ".concat(recurrencePeriod).concat(maxCharges != null ? ", ".concat(maxCharges, " times") : ''),
    intent: 'recurring'
  });
  return serviceBillingModel.accept(billing, {
    visitOneTimeManual: () => ({
      text: 'Billed once',
      intent: 'onetime-manual'
    }),
    visitOnApproval: () => ({
      text: 'Billed once, on proposal acceptance',
      intent: 'approval'
    }),
    visitOneTimeInStages: billing => ({
      text: "Billed in ".concat(pluralize('stage', billing.oneTimeInStages.numStages(), true)),
      intent: 'onetime-in-stages'
    }),
    visitRepeatableManual: handleRecurring,
    visitOngoing: handleRecurring
  });
}
export function getLimitedTimeDiscountOfferCalloutTextForService(service) {
  const offer = serviceModel.limitedTimeDiscountOffer(service);
  if (!offer) return null;
  if (offer.IsUntil()) {
    return getExpirationDateMessage(offer.ExpirationDate());
  }
  if (offer.IsWithin()) {
    if (offer.ExpirationDate()) {
      return getExpirationDateMessage(offer.ExpirationDate());
    }
    const expirationDays = offer.ExpirationDays();
    if (!expirationDays) return null;
    return "Discounted rates apply if this proposal is approved within ".concat(expirationDays, " days.");
  }
  return null;
}